import { DocumentsResponseItem } from './documents-response-item';
import { DocumentEventCode } from './documents-events.enum';

export interface GetDocumentsResponse {
  count: number;
  documents: DocumentsResponseItem[];
}

export interface DocumentAssignee {
  userAccount: string;
  fullName: string;
}

export interface DocumentStatus {
  documentStatusId: number;
  documentStatusCode: string;
  documentStatusDesc: string;
}

export interface DocumentEventLog {
  eventLogId: number;
  eventLogCode: DocumentEventCode;
  eventLogUserAccount: string;
  eventLogDateTime: string;
}

/**
 * Uploaded Document (Multiple orders and Demand Schedule files)
 */
export interface Upload {
  documentId: number;
  documentName: string;
  guid?: string;
  extension?: string;
  documentType?: {
    documentTypeId: number
    documentTypeCode: string
    documentTypeDesc: string
  };
  documentStatus?: DocumentStatus;
  customer?: {
    customerId: number
    customerCode: string
    customerDesc: string
  };
  productLine?: {
    productLineId: number
    productLineCode: string
    productLineDesc: string
  };
  serviceCenter?: {
    serviceCenterId: number
    serviceCenterDesc: string
  };
  user?: DocumentAssignee;
  assignation?: {
    assignedTo: DocumentAssignee
    assignedBy?: DocumentAssignee
  };
  eventLogs?: DocumentEventLog[];
  createdDate?: string;
  updatedDate?: string;
  uploadedDateTime?: string;
  countryCode?: string;
  errorMessage?: string;
}
